'use client';

import { useParams } from 'next/navigation';
import { PropsWithChildren } from 'react';

import { useSelectorScrollLogging } from '@flipster/features/src/shared/scroll-logging';
import { css } from '@flipster/styled-system/css';
import segment, { MarketingEvent } from '@flipster/utils/segment';

export const MainWithLogging = ({ children }: PropsWithChildren) => {
  const { slug } = useParams<{ slug: string }>();

  const ref = useSelectorScrollLogging('h1, h2', (index, dataset) => {
    segment.track(MarketingEvent.MarketingLandingScrolled, {
      scroll_direction: 'vertical',
      path: slug,
      section_type: dataset.sectionType ?? 'unknown',
      section_index: index.toString(),
    });
  });

  return (
    <main className={css({ color: 'content.default.level-5' })} ref={ref}>
      {children}
    </main>
  );
};
